// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { MetricIn } from './metricIn.zod.ts';

export const caseUpdateInAchievementsOneMax = 20000;

export const caseUpdateInAliasesOneItemMax = 200;

export const caseUpdateInAliasesOneMax = 20;

export const caseUpdateInAnonymizedLabelOneMax = 120;

export const caseUpdateInApproachOneMax = 20000;

export const caseUpdateInClientNameOneMax = 200;

export const caseUpdateInCountryOneMax = 6;

export const caseUpdateInMetricsOneMax = 50;

export const caseUpdateInObjectiveOneMax = 20000;

export const caseUpdateInSituationOneMax = 20000;

export const CaseUpdateIn = zod.object({
  "achievements": zod.union([zod.string().max(caseUpdateInAchievementsOneMax),zod.null()]).optional(),
  "aliases": zod.union([zod.array(zod.string().max(caseUpdateInAliasesOneItemMax)).max(caseUpdateInAliasesOneMax),zod.null()]).optional(),
  "anonymized_label": zod.union([zod.string().min(1).max(caseUpdateInAnonymizedLabelOneMax),zod.null()]).optional(),
  "approach": zod.union([zod.string().max(caseUpdateInApproachOneMax),zod.null()]).optional(),
  "client_name": zod.union([zod.string().max(caseUpdateInClientNameOneMax),zod.null()]).optional(),
  "country": zod.union([zod.string().max(caseUpdateInCountryOneMax),zod.null()]).optional(),
  "industry_id": zod.union([zod.uuid(),zod.null()]).optional(),
  "metrics": zod.union([zod.array(MetricIn).max(caseUpdateInMetricsOneMax),zod.null()]).optional(),
  "objective": zod.union([zod.string().max(caseUpdateInObjectiveOneMax),zod.null()]).optional(),
  "situation": zod.union([zod.string().max(caseUpdateInSituationOneMax),zod.null()]).optional(),
  "status": zod.union([zod.enum(['live', 'pilot', 'pipeline', 'closed']),zod.null()]).optional(),
  "type": zod.union([zod.enum(['client', 'benchmark']),zod.null()]).optional()
});

export type CaseUpdateIn = zod.input<typeof CaseUpdateIn>;
export type CaseUpdateInOutput = zod.output<typeof CaseUpdateIn>;
